import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from './intl';

export const InsuranceProviderPropType = PropTypes.shape({
  insuranceProviderId: PropTypes.string,
  messageDescriptor: MessageDescriptorPropType,
  name: PropTypes.string,
});

/**
 * @typedef InsuranceProviderPropType
 * @property {string} insuranceProviderId
 * @property {MessageDescriptorPropType} messageDescriptor
 * @property {string} name
 */
